export const EmploymentStatus = {
  privateFullTime: {
    short: "Private (Full-Time)",
    full: "Employed in Private or Semi-Govt Sector Full-Time"
  },
  privatePartTime: {
    short: "Private (Part-Time)",
    full: "Employed in Private or Semi-Govt Sector Part-Time"
  },
  governmentEmployee: {
    short: "Govt Employee",
    full: "Government Employee"
  },
  freelance: {
    short: "Freelancer",
    full: "Freelancer/Gig Worker"
  },
  student: {
    short: "Student",
    full: "Student"
  },
  retired: {
    short: "Retired",
    full: "Retired"
  }
} as const;

export const IncomeSource = {
  salary: {
    short: "Salary",
    full: "Salary from employment"
  },
  freelance: {
    short: "Freelance",
    full: "Freelance or gig-work income"
  },
  sideHustle: {
    short: "Side Hustle",
    full: "Side hustle"
  },
  business: {
    short: "Business",
    full: "Personal/Family Business Income"
  },
  pension: {
    short: "Pension",
    full: "Pension"
  },
  support: {
    short: "Family Support",
    full: "Support from family"
  },
  rental: {
    short: "Rental",
    full: "Rental income"
  },
  noIncome: {
    short: "No Income",
    full: "I currently have no income"
  }
} as const;

export const getEmploymentStatusLabel = (status: string, short = false): string => {
  const statusObj = EmploymentStatus[status as keyof typeof EmploymentStatus];
  return statusObj ? (short ? statusObj.short : statusObj.full) : status;
};

export const getIncomeSourceLabel = (source: string, short = false): string => {
  const sourceObj = IncomeSource[source as keyof typeof IncomeSource];
  return sourceObj ? (short ? sourceObj.short : sourceObj.full) : source;
};
